// extracted by mini-css-extract-plugin
module.exports = {"container":"IntroSection_container__VUeSn","content":"IntroSection_content__GSYYO","scroller":"IntroSection_scroller__p29xW"};